// Shared palette for the Israel patient scheduling UI (from Wireframe #2).
export const IL = {
  green: '#5FB78A', // primary accent (CTA active, available, selected)
  greenDark: '#4FA579',
  greenDeep: '#2F6F54', // booked-editable card fill (dark green)
  red: '#E36B76', // cancel / expired
  dark: '#3B3B3B',
  teal: '#2B4A57', // panel frame + booked-locked card fill
  blueGrey: '#A5AFBF', // idle "schedule" CTA fill
  border: '#C9CDD2',
  light: '#E9EBEE', // grey boxes / disabled buttons
  muted: '#8A8F97',
  saturday: '#D9534F', // Saturday / unavailable day text
  pageBg: '#F1F3F5',
  white: '#FFFFFF',
} as const;

export const HEBREW_MONTHS = [
  'ינואר',
  'פברואר',
  'מרץ',
  'אפריל',
  'מאי',
  'יוני',
  'יולי',
  'אוגוסט',
  'ספטמבר',
  'אוקטובר',
  'נובמבר',
  'דצמבר',
];

// Sunday-first, matching the wireframe's left→right column order (Saturday last).
export const HEBREW_WEEKDAYS = ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'];

// Date helpers — the calendar works purely in "YYYY-MM-DD" calendar space
// (no timezone math); slot `date` fields are already in that form.
const pad = (n: number) => String(n).padStart(2, '0');

export function ymd(d: Date): string {
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}

export function todayYmd(): string {
  return ymd(new Date());
}
